import { faSpinnerThird } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";

export default function LoadingSpinner() {
  return (
    <Box
      component="span"
      sx={{ color: "primary.main", display: "inline-flex" }}
    >
      <FontAwesomeIcon icon={faSpinnerThird} spin />
    </Box>
  );
}
